<div class="logo">
  {{mark}}
</div>
